module.exports = __webpack_public_path__ + "img/p60.3b316142.png";